import Author from './Author.vue'

export default Author
